import HighlightText from './HighlightText'
export default HighlightText
export type { IHighlightText } from './HighlightText.types'
